import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';
import Button from './Button';

const Title = styled.h2`
  margin: 0 0 ${theme.spacing.lg} 0;
  color: ${theme.colors.text};
  text-align: center;
  font-size: ${theme.typography.fontSizes.xxl};
  font-weight: ${theme.typography.fontWeights.bold};
  font-family: ${theme.typography.fontFamily};
`;

const DiagramContainer = styled.div`
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid ${theme.colors.border};
  overflow: hidden;
  margin-bottom: ${theme.spacing.xl};

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const TipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.xl};
`;

const TipItem = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background-color: rgba(114, 210, 255, 0.06);
  border: 1px solid ${theme.colors.borderLight};
  border-radius: ${theme.borderRadius.md};
  line-height: 1.5;
`;

const TipNumber = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: ${theme.borderRadius.full};
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryDark} 100%);
  color: ${theme.colors.text};
  font-size: ${theme.typography.fontSizes.sm};
  font-weight: ${theme.typography.fontWeights.bold};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
`;

const TipText = styled.div`
  font-size: ${theme.typography.fontSizes.sm};
  color: ${theme.colors.textSecondary};

  strong {
    color: ${theme.colors.text};
    font-weight: ${theme.typography.fontWeights.medium};
  }
`;

const TIPS = [
  {
    title: 'Centered behind the baseline',
    text: 'The camera should be positioned more or less centered at the back of the court, aligned with the center service line.',
  },
  {
    title: 'Elevated position',
    text: 'The camera should be elevated above court level. Higher is better. The more elevation, the better the tracking accuracy.',
  },
  {
    title: 'No side angles',
    text: 'We do not support side-angle footage. The camera must be positioned behind one of the baselines.',
  },
];

const VideoSetupGuide = ({ onBack }) => {
  return (
    <>
      <Title>Camera Setup Guide</Title>
      <DiagramContainer>
        <img src="/images/camera_setup.svg" alt="Ideal camera setup: centered behind the baseline, elevated above court level" />
      </DiagramContainer>
      <TipList>
        {TIPS.map((tip, i) => (
          <TipItem key={i}>
            <TipNumber>{i + 1}</TipNumber>
            <TipText>
              <strong>{tip.title}.</strong> {tip.text}
            </TipText>
          </TipItem>
        ))}
      </TipList>
      <Button type="button" onClick={onBack} style={{ width: '100%' }}>
        Got it
      </Button>
    </>
  );
};

export default VideoSetupGuide;
